(function(angular){
	'use strict';

	angular
		.module('momentModule', [])
		.value('moment', moment);

})(window.angular);
